import UniversityList from './UniversityList.gql';

export default UniversityList;
